import * as React from 'react'
import { Admin, Resource } from 'react-admin'
import dynamoProvider from './providers/dynamo'
import cognitoProvider, { useAuthLoading } from './providers/cognito'
import * as Course from './resources/courses'
import * as Assessment from './resources/assessments'
import * as Instance from './resources/assessment_instances'
import * as Student from './resources/students'
import * as StudentGroup from './resources/student_groups'
import * as Survey from './resources/surveys'
import * as Assignment from './resources/assignments'
import * as Ranking from './resources/rankings'
import * as MAJCOM from './resources/majcom'
import * as AFSC from './resources/afsc'
import * as Attempt from './resources/attempts'
import * as Disqualification from './resources/disqualifications'
import * as Event from './resources/events'
import * as User from './resources/users'
import Dashboard from './components/Dashboard'
import Layout from './components/Layout'
import Analytics from './components/Analytics'
import { Route } from 'react-router-dom'
import { ConsentModal } from './components/ConsentModal'

const customRoutes = [<Route exact path="/analytics" component={Analytics} />]

export default () => {
  const loading = useAuthLoading()

  if (loading) return null

  return (
    <Admin
      disableTelemetry
      dashboard={Dashboard}
      layout={Layout}
      customRoutes={customRoutes}
      authProvider={cognitoProvider}
      dataProvider={dynamoProvider}
    >
      {(perm) => [
        <Resource
          name="courses"
          options={{ label: 'Courses' }}
          {...getRoutes(Course, perm)}
        />,
        <Resource
          name="surveys"
          options={{ label: 'Pre-Course Surveys' }}
          {...getRoutes(Survey, perm)}
        />,
        <Resource
          name="assessments"
          options={{ label: 'Assessments' }}
          {...getRoutes(Assessment, perm)}
        />,
        <Resource
          name="events"
          options={{ label: 'Assessment Events' }}
          {...getRoutes(Event, perm)}
        />,
        <Resource
          name="instances"
          options={{ label: 'Assessment Schedule' }}
          {...getRoutes(Instance, perm)}
        />,
        <Resource
          name="student_groups"
          options={{ label: 'Classes' }}
          {...getRoutes(StudentGroup, perm)}
        />,
        <Resource
          name="students"
          options={{ label: 'Students' }}
          {...getRoutes(Student, perm)}
        />,
        <Resource
          name="assignments"
          options={{ label: 'Student Assignments' }}
          {...getRoutes(Assignment, perm, true, true)}
        />,
        <Resource
          name="attempts"
          options={{ label: 'Student Event Attempts' }}
          {...getRoutes(Attempt, perm)}
        />,
        <Resource
          name="disqualifications"
          options={{ label: 'Student Disqualifications' }}
          {...getRoutes(Disqualification, perm)}
        />,
        <Resource
          name="users"
          options={{ label: 'Staff' }}
          {...getRoutes(User, perm, true)}
        />,
        <Resource
          name="rankings"
          options={{ label: 'Rankings' }}
          {...getRoutes(Ranking, perm, true, true)}
        />,
        <Resource
          name="majcom"
          options={{ label: 'MAJCOM' }}
          {...getRoutes(MAJCOM, perm, true, true)}
        />,
        <Resource
          name="afsc"
          options={{ label: 'AFSC' }}
          {...getRoutes(AFSC, perm, true, true)}
        />,
        <ConsentModal />,
      ]}
    </Admin>
  )
}

const getRoutes = (route, permissions, allowEdit, allowCreate) => ({
  ...route,
  edit:
    permissions.includes('admin') ||
    (allowEdit && permissions.includes('director'))
      ? route.edit
      : null,
  create:
    permissions.includes('admin') ||
    (allowCreate && permissions.includes('director'))
      ? route.create
      : null,
})
